import script from "./Tasks.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tasks.vue?vue&type=script&lang=ts&setup=true"

import "./Tasks.vue?vue&type=style&index=0&id=2106ac75&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2106ac75"]])

export default __exports__